export default __webpack_public_path__ + "static/image12-6a402b2d326a56d0c22446adf563a726.jpg";